export const SDK_VERSION = '7.18.0';
